const RightSideBarSkeleton = ({ height }) => {
  return (
    <div className="col-12 col-xl-3">
      <div
        className="card shadow-lg border-0"
        style={{
          borderRadius: "0.75rem",
          overflow: "hidden",
        }}
      >
        {/* Header Skeleton */}
        <div
          className="card-header d-flex align-items-center justify-content-between"
          style={{
            background: "linear-gradient(135deg, #00b4d8)",
            borderBottom: "none",
            padding: "0.75rem 1.25rem",
          }}
        >
          <div
            className="bg-light rounded"
            style={{ width: "180px", height: "24px", opacity: 0.3 }}
          />
        </div>

        {/* Body Skeleton */}
        <div
          className="card-body"
          style={{
            maxHeight: height,
            overflowY: "auto",
            padding: "1rem 1.25rem",
          }}
        >
          {/* Timeline Items Skeleton */}
          {[1, 2, 3, 4].map((item, i) => (
            <div key={i} className="d-flex position-relative mb-4">
              {/* Timeline connector */}
              {i < 3 && (
                <div
                  className="position-absolute"
                  style={{
                    left: "8px",
                    top: "14px",
                    bottom: 0,
                    width: "2px",
                    backgroundColor: "rgba(0,0,0,0.1)",
                  }}
                />
              )}

              {/* Timeline icon skeleton */}
              <div
                className="rounded-circle flex-shrink-0 mr-3 position-relative bg-secondary"
                style={{
                  width: "18px",
                  height: "18px",
                  opacity: 0.3,
                }}
              />

              {/* Timeline text skeleton */}
              <div className="ml-2 flex-grow-1">
                <div
                  className="bg-secondary rounded mb-2"
                  style={{
                    width: i === 0 ? "150px" : "180px",
                    height: "16px",
                    opacity: 0.3,
                  }}
                />
                <div
                  className="bg-secondary rounded"
                  style={{
                    width: "120px",
                    height: "14px",
                    opacity: 0.2,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RightSideBarSkeleton;
